import { useBoolean, useEventListener } from 'usehooks-ts';

export function useNetworkStatus() {
  const { value, setTrue, setFalse } = useBoolean(navigator.onLine);

  useEventListener('online', setTrue);
  useEventListener('offline', setFalse);

  return {
    isOnline: value,
  };
}
